/**
 * Aquest fitxer és per a JS al front-end si vols afegir comportaments dinàmics.
 * En aquest cas només farem un log de comprovació.
 */
console.log('Bloc de metadades carregat al frontend');
